// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Injectable } from '@movecloser/front-core';
import { EModal } from '@contract/modal';
import { ModalMode } from '@modules/dsl/bootstrap/Modal';
let CommentService = class CommentService {
    constructor(commentRepository, modalConnectorService, authService) {
        this.commentRepository = commentRepository;
        this.modalConnector = modalConnectorService;
        this.authService = authService;
    }
    open(parent) {
        this.modalConnector.open(EModal.Comments, { parent }, { mode: ModalMode.Drawer });
    }
    close() {
        this.modalConnector.close(EModal.Comments);
    }
    async load(contentId, page = 1, parentId) {
        const authorizationHeader = this.authService.getAuthorizationHeader();
        const query = {
            page
        };
        if (parentId) {
            query.parentId = parentId;
        }
        try {
            return await this.commentRepository.loadCollection(contentId, authorizationHeader, query);
        }
        catch (error) {
            console.error(error);
        }
        return null;
    }
    async deleteComment(commentId) {
        return this.commentRepository.deleteComment(commentId);
    }
    async addComment(contentId, message, parentId = null) {
        const payload = {
            content: message,
            parentId,
            owner: contentId
        };
        return this.commentRepository.addComment(payload);
    }
};
CommentService = __decorate([
    Injectable()
], CommentService);
export { CommentService };
